import React from 'react';
import { useTranslation } from 'react-i18next';

const CareersPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden p-8">
        <div className="text-center mb-10 border-b pb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">{t('careersPage.title')}</h1>
          <p className="text-lg text-gray-600">{t('careersPage.subtitle')}</p>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('careersPage.intro.title')}</h2>
            <p className="mb-4">{t('careersPage.intro.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('careersPage.areas.title')}</h2>
            <ul className="list-none space-y-3">
              <li className="flex items-start">
                <span className="mr-2 text-blue-600 font-bold">&#8226;</span>
                <span>{t('careersPage.areas.realEstate')}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-blue-600 font-bold">&#8226;</span>
                <span>{t('careersPage.areas.technology')}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-blue-600 font-bold">&#8226;</span>
                <span>{t('careersPage.areas.clientServices')}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-blue-600 font-bold">&#8226;</span>
                <span>{t('careersPage.areas.operations')}</span>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('careersPage.benefits.title')}</h2>
            <p className="mb-4">{t('careersPage.benefits.content')}</p>
          </section>

          <section>
            <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
              <h2 className="text-2xl font-bold mb-4 text-blue-800">{t('careersPage.apply.title')}</h2>
              <p>{t('careersPage.apply.content')}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CareersPage;
